import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { Button } from './Button';
export function WholesaleValue() {
  const items = [{
    name: 'Amazon FBA Wholesale Desde Cero™',
    value: '$67 USD'
  }, {
    name: 'Bono Premium #1',
    value: '$37 USD'
  }, {
    name: 'Bono Premium #2',
    value: '$27 USD'
  }];
  return <section className="bg-brand-beige py-20 px-6" data-id="element-1029">
      <div className="max-w-3xl mx-auto" data-id="element-1030">
        <FadeIn data-id="element-1031">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border border-brand-gold/20" data-id="element-1032">
            <div className="text-center mb-8" data-id="element-1033">
              <Sparkles className="w-10 h-10 text-brand-gold mx-auto mb-4" data-id="element-1034" />
              <h2 className="text-3xl md:text-4xl font-bold text-brand-green" data-id="element-1035">
                TODO LO QUE RECIBES HOY
              </h2>
            </div>

            <div className="space-y-4 mb-8" data-id="element-1036">
              {items.map((item, index) => <div key={index} className="flex items-center justify-between py-3 border-b border-brand-text/10 last:border-0" data-id="element-1037">
                  <div className="flex items-center gap-3" data-id="element-1038">
                    <CheckCircle2 className="w-5 h-5 text-brand-green" data-id="element-1039" />
                    <span className="text-brand-text/80 font-medium" data-id="element-1040">
                      {item.name}
                    </span>
                  </div>
                  <span className="font-bold text-brand-text/60 line-through" data-id="element-1041">
                    {item.value}
                  </span>
                </div>)}
            </div>

            <div className="bg-brand-green/5 rounded-2xl p-6 text-center mb-8 border border-brand-green/10" data-id="element-1042">
              <p className="text-sm font-bold text-brand-text/60 uppercase tracking-widest mb-2" data-id="element-1043">
                TOTAL VISUAL
              </p>
              <p className="text-3xl md:text-4xl font-bold text-brand-green line-through opacity-50 mb-4" data-id="element-1044">
                $131 USD+
              </p>
              <p className="text-sm font-bold text-brand-gold uppercase tracking-widest mb-2" data-id="element-1045">
                HOY SOLO
              </p>
              <p className="text-6xl md:text-7xl font-bold text-brand-green mb-2" data-id="element-1046">
                $19.99 <span className="text-3xl" data-id="element-1047">USD</span>
              </p>
              <p className="text-sm text-brand-text/60" data-id="element-1048">
                Oferta de lanzamiento disponible por tiempo limitado.
              </p>
            </div>

            <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-wholesale-desde-cero-2026', '_blank', 'noopener,noreferrer')} className="w-full text-lg py-5" data-id="element-1049">
              QUIERO APRENDER WHOLESALE
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}